import React, { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";
import Success from "../SVGS/status/Success";
import ErrorIcon from "../SVGS/status/ErrorIcon";
import Info from "../SVGS/status/Info";
import WarningStatus from "../SVGS/status/WarningStatus";
import Default from "../SVGS/status/Default";
import { useDispatch, useSelector } from "react-redux";
import { setCloseToast } from "../../store/toast";

const ToastApp = () => {
  const { status, message, show, description } = useSelector(
    (state) => state.toast
  );
  const dispatch = useDispatch();
  const getIcon = (status) => {
    switch (status) {
      case "success":
        return <Success />;
      case "error":
        return <ErrorIcon />;
      case "info":
        return <Info />;
      case "warning":
        return <WarningStatus />;
      default:
        return <Default />;
    }
  };
  useEffect(() => {
    // return dispatch(setToast({ message: "", status: "" }));
  }, [show]);

  return (
    <Toast
      onClose={() => dispatch(setCloseToast())}
      show={show}
      delay={5000}
      autohide
    >
      <Toast.Header>
        {getIcon(status)}
        <div className="d-flex flex-column">
          <span style={{ fontWeight: "bold" }}>{message}</span>
          <span>{description}</span>
        </div>
      </Toast.Header>
    </Toast>
  );
};

export default ToastApp;
